import React from "react";
import {
  Alert,
  Box,
  Button,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Typography,
} from "@mui/material";
import {
  AccountBalanceRounded,
  ArrowBackRounded,
  ArrowForwardRounded,
  DescriptionRounded,
  FolderCopyRounded,
  SchoolRounded,
} from "@mui/icons-material";
import { ajustarTamanhoFonteEscola, coresTextosGlobais, tamanhosPaginasAdministrativas, tamanhosControlesGlobais } from "../../../estilos/global";
const azul = "var(--sear-azul, #087cf0)";
const texto = "var(--sear-texto, #244c7c)";
const secundario = "var(--sear-texto-secundario, #6d849e)";
const borda = "var(--sear-borda, #d7e7f7)";
function Campo({ label, value, onChange, children, placeholder, disabled = false }) {
  return (
    <Box sx={{ minWidth: 0 }}>
      <Typography
        component="label"
        sx={{
          display: "block",
          fontSize: ajustarTamanhoFonteEscola("0.82rem"),
          fontWeight: 600,
          color: texto,
          mb: 0.4,
        }}
      >
        {label}{" "}
        <Box component="span" sx={{ color: "error.main" }}>
          *
        </Box>
      </Typography>
      <Select
        fullWidth
        size="small"
        displayEmpty
        disabled={disabled}
        value={value}
        onChange={onChange}
        inputProps={{ "aria-label": label }}
        sx={{
          fontSize: ajustarTamanhoFonteEscola("0.82rem"),
          color: texto,
          minHeight: 36,
          "& .MuiSelect-select": {
            display: "flex",
            alignItems: "center",
            gap: 0.75,
            py: 0.75,
          },
          "& fieldset": { borderColor: borda },
        }}
      >
        <MenuItem disabled value="">
          {placeholder}
        </MenuItem>
        {children}
      </Select>
    </Box>
  );
}
function IconeCampo({ children }) {
  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        mr: 1,
        color: azul,
        verticalAlign: "middle",
      }}
    >
      {children}
    </Box>
  );
}
function IlustracaoPasta() {
  return (
    <Box
      component="svg"
      viewBox="0 0 150 90"
      aria-hidden="true"
      sx={{
        width: 80,
        height: 48,
        position: "absolute",
        right: 10,
        bottom: 0,
        opacity: 0.8,
        display: { xs: "none", sm: "block" },
      }}
    >
      <path d="M8 77 18 20Q20 10 30 16l18 22L139 9l-5 65Z" fill="#a9d5ff" />
      <path d="M37 74V26q0-9 10-9h25l10 10h31q9 0 9 9v38Z" fill="#fff" />
      <circle cx="114" cy="68" r="20" fill="#51a4ff" />
      <path
        d="M114 59v18m-9-9h18"
        stroke="white"
        strokeWidth="5"
        strokeLinecap="round"
      />
    </Box>
  );
}
export default function FormularioNovoProcesso({
  carregando = false,
  carga = { cadastro: carregando, mantenedora: carregando, escolas: carregando, tipos: carregando },
  erroCarga = "",
  onRecarregar,
  mantenedora,
  mantenedoraSelecionada,
  onMantenedora,
  tipoInstituicao,
  onTipoInstituicao,
  escolas,
  selectedSchool,
  onEscola,
  tipos,
  processType,
  onProcesso,
  descricao,
  mensagem,
  onContinuar,
  onVoltar,
  valido,
}) {
  const bloqueado = carga.cadastro || Boolean(erroCarga);
  const escola = escolas.find(
    (item) => String(item.id) === String(selectedSchool),
  );
  const processo = tipos.find(
    (item) => String(item.id) === String(processType),
  );
  const iconStyle = { fontSize: 22 };
  return (
    <Box sx={{ display: "grid", gap: 0.75 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.4,
          mb: 0.75,
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            display: "grid",
            placeItems: "center",
            width: 44,
            height: 44,
            flexShrink: 0,
            bgcolor: "var(--sear-superficie-azul, #e8f4ff)",
            borderRadius: 1.5,
            color: azul,
          }}
        >
          <FolderCopyRounded sx={{ fontSize: 27 }} />
        </Box>
        <Box sx={{ minWidth: 0, zIndex: 1 }}>
          <Typography
            component="h1"
            sx={{
              fontSize: tamanhosPaginasAdministrativas.tituloPagina,
              fontWeight: 700,
              lineHeight: 1.15,
              color: coresTextosGlobais.tituloPagina,
            }}
          >
            Criar Novo Processo
          </Typography>
          <Typography
            sx={{
              mt: 0.3,
              fontSize: tamanhosControlesGlobais.descricao,
              color: secundario,
            }}
          >
            Selecione a instituição e o processo que deseja iniciar.
          </Typography>
        </Box>
        <IlustracaoPasta />
      </Box>
      <Box
        component="form"
        onSubmit={bloqueado || carregando ? (event) => event.preventDefault() : onContinuar}
        sx={{
          p: 1,
          border: `1px solid ${borda}`,
          borderRadius: 1.2,
          bgcolor: "var(--sear-superficie, #fff)",
          display: "grid",
          gap: 0.75,
        }}
      >
        {erroCarga && (
          <Alert severity="error" action={<Button onClick={onRecarregar}>Tentar novamente</Button>}>
            {erroCarga}
          </Alert>
        )}
        <Campo
          disabled={bloqueado || carga.mantenedora}
          label="Selecione a mantenedora"
          placeholder="Selecione a mantenedora"
          value={mantenedoraSelecionada}
          onChange={onMantenedora}
        >
          {mantenedora && (
            <MenuItem value={mantenedora.id}>
              <IconeCampo>
                <AccountBalanceRounded sx={iconStyle} />
              </IconeCampo>
              {mantenedora.nome}
            </MenuItem>
          )}
        </Campo>
        <Box>
          <Typography
            sx={{
              fontSize: ajustarTamanhoFonteEscola("0.82rem"),
              fontWeight: 600,
              color: texto,
              mb: 0.4,
            }}
          >
            Para qual instituição será o processo?{" "}
            <Box component="span" sx={{ color: "error.main" }}>
              *
            </Box>
          </Typography>
          <RadioGroup
            row
            value={tipoInstituicao}
            onChange={onTipoInstituicao}
            aria-label="Para qual instituição será o processo?"
            aria-required="true"
            sx={{ gap: 1, flexWrap: "nowrap" }}
          >
            {[
              {
                valor: "mantenedora",
                nome: "Mantenedora",
                icone: <AccountBalanceRounded />,
                descricao: "Para a mantenedora.",
              },
              {
                valor: "escola",
                nome: "Escola",
                icone: <SchoolRounded />,
                descricao: "Para a escola.",
              },
            ].map((opcao) => (
              <FormControlLabel
                disabled={bloqueado}
                key={opcao.valor}
                value={opcao.valor}
                labelPlacement="start"
                control={<Radio size="small" />}
                label={
                  <Box sx={{ display: "flex", gap: 1, alignItems: "center", minWidth: 0 }}>
                    <Box
                      sx={{
                        color: azul,
                        bgcolor: "var(--sear-superficie-azul, #eaf5ff)",
                        p: 0.65,
                        borderRadius: 1,
                        display: "flex",
                      }}
                    >
                      {opcao.icone}
                    </Box>
                    <Box>
                      <Typography
                        sx={{
                          fontWeight: 600,
                          fontSize: ajustarTamanhoFonteEscola("0.84rem"),
                          color: texto,
                        }}
                      >
                        {opcao.nome}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: ajustarTamanhoFonteEscola("0.73rem"),
                          color: secundario,
                        }}
                      >
                        {opcao.descricao}
                      </Typography>
                    </Box>
                  </Box>
                }
                sx={{
                  m: 0,
                  p: 0.75,
                  pr: 0.25,
                  flex: 1,
                  minWidth: 0,
                  minHeight: 52,
                  justifyContent: "space-between",
                  border: `1px solid ${tipoInstituicao === opcao.valor ? azul : borda}`,
                  borderRadius: 1,
                  bgcolor:
                    tipoInstituicao === opcao.valor
                      ? "var(--sear-superficie-azul, #eef7ff)"
                      : "transparent",
                }}
              />
            ))}
          </RadioGroup>
        </Box>
        <Box sx={{
          display: "grid",
          gap: 1.25,
          gridTemplateColumns: "minmax(0, 1fr)",
          "@media (min-width: 480px)": {
            gridTemplateColumns: tipoInstituicao === "escola"
              ? "repeat(2, minmax(0, 1fr))" : "minmax(0, 1fr)",
          },
        }}>
          {tipoInstituicao === "escola" && (
            <Campo
              disabled={bloqueado || carga.escolas}
              label="Selecione a escola"
              placeholder="Selecione a escola"
              value={selectedSchool}
              onChange={onEscola}
            >
              {escolas.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  <IconeCampo>
                    <SchoolRounded sx={iconStyle} />
                  </IconeCampo>
                  {item.nome}
                </MenuItem>
              ))}
            </Campo>
          )}
          <Campo
            disabled={bloqueado || carga.tipos}
            label="Tipo do processo"
            placeholder="Selecione o tipo do processo"
            value={processType}
            onChange={onProcesso}
          >
            {tipos.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                <IconeCampo>
                  <FolderCopyRounded sx={iconStyle} />
                </IconeCampo>
                {item.nome}
              </MenuItem>
            ))}
          </Campo>
        </Box>
        {!carga.tipos && tipoInstituicao && !tipos.length && (
          <Alert severity="info">
            Não há tipos de processo disponíveis para esta categoria no momento.
          </Alert>
        )}
        {!carga.escolas && tipoInstituicao === "escola" && !escolas.length && (
          <Alert severity="info">
            Não há escola autorizada disponível para este processo.
          </Alert>
        )}
        {mensagem && <Alert severity="warning">{mensagem}</Alert>}
        <Box>
          <Typography
            sx={{
              fontSize: ajustarTamanhoFonteEscola("0.82rem"),
              fontWeight: 600,
              color: texto,
              mb: 0.4,
            }}
          >
            Descrição do processo
          </Typography>
          <Box
            sx={{
              display: "flex",
              gap: 1,
              alignItems: "center",
              p: 0.75,
              bgcolor: "var(--sear-superficie-suave, #f0f4f8)",
              borderRadius: 1,
            }}
          >
            <DescriptionRounded
              sx={{ color: "var(--sear-texto-suave, #a6b7cc)", fontSize: 22, flexShrink: 0 }}
            />
            <Typography
              sx={{
                fontSize: ajustarTamanhoFonteEscola("0.82rem"),
                color: secundario,
              }}
            >
              {descricao ||
                "Selecione o tipo do processo para consultar a descrição."}
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            p: 0.5,
            bgcolor: "var(--sear-superficie-azul, #eaf5ff)",
            borderRadius: 1,
          }}
        >
          <Typography
            sx={{
              color: azul,
              fontWeight: 600,
              fontSize: ajustarTamanhoFonteEscola("0.84rem"),
              mb: 0.25,
            }}
          >
            Resumo do processo
          </Typography>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "minmax(0, 1fr)",
              "@media (min-width: 480px)": { gridTemplateColumns: "repeat(3, minmax(0, 1fr))" },
              gap: 1,
            }}
          >
            {[
              {
                titulo: "Mantenedora",
                valor: mantenedoraSelecionada
                  ? mantenedora?.nome
                  : "Não selecionada",
                icone: <AccountBalanceRounded />,
              },
              {
                titulo: "Instituição",
                valor:
                  tipoInstituicao === "escola"
                    ? "Escola"
                    : tipoInstituicao === "mantenedora"
                      ? "Mantenedora"
                      : "Não selecionado",
                detalhe:
                  tipoInstituicao === "escola" ? escola?.nome : undefined,
                icone:
                  tipoInstituicao === "escola" ? (
                    <SchoolRounded />
                  ) : (
                    <AccountBalanceRounded />
                  ),
              },
              {
                titulo: "Processo",
                valor: processo?.nome || "Não selecionado",
                icone: <FolderCopyRounded />,
              },
            ].map((item) => (
              <Box
                key={item.titulo}
                sx={{ display: "flex", gap: 0.75, alignItems: "center", minWidth: 0 }}
              >
                <IconeCampo>{item.icone}</IconeCampo>
                <Box>
                  <Typography
                    sx={{
                      fontSize: ajustarTamanhoFonteEscola("0.72rem"),
                      color: secundario,
                    }}
                  >
                    {item.titulo}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: ajustarTamanhoFonteEscola("0.82rem"),
                      fontWeight: 600,
                      color: texto,
                    }}
                  >
                    {item.valor}
                  </Typography>
                  {item.detalhe && (
                    <Typography
                      sx={{
                        fontSize: ajustarTamanhoFonteEscola("0.72rem"),
                        color: secundario,
                      }}
                    >
                      {item.detalhe}
                    </Typography>
                  )}
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            borderTop: `1px solid ${borda}`,
            pt: 0.5,
            gap: 1,
            mt: 0,
          }}
        >
          <Button
            variant="outlined"
            startIcon={<ArrowBackRounded />}
            onClick={onVoltar}
            sx={{ textTransform: "none" }}
          >
            Voltar
          </Button>
          <Button
            type="submit"
            variant="contained"
            disabled={bloqueado || carregando || !valido}
            endIcon={<ArrowForwardRounded />}
            sx={{ textTransform: "none", minWidth: 137 }}
          >
            Continuar
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
